import React from 'react';

import { link } from '@aline/routes';
import { IconButton, TableCell, TableRow, Typography, useTheme } from '@mui/material';
import clsx from 'clsx';
import { AlineAvatar, usePermissionRowStyles } from 'src/components';
import { EditIcon } from 'src/components/icons/EditIcon';
import type { Apollo } from 'src/gql/generated';
import { openLink } from 'src/helpers';

type GroupRowType = Pick<Apollo.Group, 'avatarColor' | 'id' | 'name' | '__typename'>;

interface GroupPermissionRowProps {
  group: GroupRowType;
}

export function GroupPermissionRow({ group }: GroupPermissionRowProps): JSX.Element {
  const theme = useTheme();
  const { classes } = usePermissionRowStyles();

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableCell} style={{ paddingRight: theme.spacing(1) }}>
        <AlineAvatar avatarInfo={group} />
      </TableCell>
      <TableCell className={clsx(classes.tableCell, classes.nameCell)}>
        <Typography variant="body1">{group.name}</Typography>
      </TableCell>
      <TableCell className={classes.roleCell} style={{ paddingRight: theme.spacing(1) }}>
        <Typography className={classes.roleText} variant="body1">
          Viewer
        </Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <IconButton size="small" onClick={() => openLink(link.AdminGroupIndex())}>
          <EditIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
